export default __webpack_public_path__ + "static/media/fridgeadd.622c6bec.jpg";